export default [
  {
    path: '/cyzsIndex/channelList',
    name: 'channelList',
    meta: {
      title: '频道列表'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/channelList/main.vue'],resolve)
    }
  },
  {
    path: '/cyzsIndex/setChannel',
    name: 'setChannel',
    meta: {
      title: '频道设置'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/channelList/setChannel.vue'],resolve)
    }
  },
  {
    path: '/cyzsIndex/cyzsEditAd',
    name: 'cyzsEditAd',
    meta: {
      title: '编辑广告位'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/advertisement/editAd.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/cyzsAdList',
    name: 'cyzsAdList',
    meta: {
      title: '广告位'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/advertisement/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/cyzsIndexPopAd',
    name: 'cyzsIndexPopAd',
    meta: {
      title: '主页弹窗广告',
      link: '/cyzsIndex/cyzsIndexPopAd',
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/indexPopAd/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/editIndexPopAd',
    name: 'editIndexPopAd',
    meta: {
      title: '编辑主页弹窗广告',
      link: '/cyzsIndex/editIndexPopAd',
      isHide: true
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/indexPopAd/editIndexPopAd.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/topic',
    name: 'cyzsIndexTopic',
    meta: {
      title: '专题'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/topic/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/editTopic',
    name: 'editTopic',
    meta: {
      title: '专题'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/topic/edit.vue'], resolve)
    }
  },
  {
    path: '/cyzsIndex/votingSetting',
    name: 'votingSetting',
    meta: {
      title: '投票设置'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsIndex/votingSetting/main.vue'], resolve)
    }
  },
]